import { Component , TemplateRef, ViewChild, PLATFORM_ID ,Inject, OnInit} from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MatDialogModule,MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { FacadeService } from '../../services/facade.service';
import { ProyectosService } from '../../services/proyectos.service';

import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';

import { HttpClient, HttpClientModule } from '@angular/common/http';

@Component({
  selector: 'app-wordlist',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule,
    HttpClientModule],
  templateUrl: './wordlist.component.html',
  styleUrl: './wordlist.component.css'
})
export class WordlistComponent {
  wordlistInput: string = '';
  originalWordlist:string = '';
  idwordlist: number;
  namewordlist: string;
  originalNamelist:string = '';
  buttonText: string = 'Copy Text';
  buttonImage: string = '';
  buttonTextColor: string = '#EEA21A'; // Color inicial
  isEditing: boolean;

  constructor(
    public dialogRef: MatDialogRef<WordlistComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fachada: FacadeService,
    private http: HttpClient,
    private clipboard: Clipboard,
    private proyectoService: ProyectosService
  ) {
    this.idwordlist = data.id
    this.wordlistInput = data.wordlist
    this.originalWordlist = data.wordlist;
    this.namewordlist = data.name
    this.originalNamelist = data.name;
    this.isEditing = data.isEditing
  }

  async createList() { 
    if(!this.isEditing){
      const data = { 
        nombre:this.namewordlist,
        wordlist: this.wordlistInput
      };
      if(this.wordlistInput.trim()){
        try{
        let response = await this.fachada.createWordlist(this.http,localStorage.getItem("text-inspector-django-token"),data)
          console.log('Wordlist creada con éxito:', response);
          this.dialogRef.close(response);
          // Aquí puedes agregar lógica para cerrar el diálogo o notificar al usuario
        } catch (error){
          console.error('Error al crear la Wordlist:', error);
      }
      }
    }else{
      const wordlistFormatted = Array.isArray(this.wordlistInput) 
    ? this.wordlistInput.join(', ')  // Une los elementos del arreglo con comas
    : this.wordlistInput; // Si no es un arreglo, usa el valor directamente
      const data = { 
        id:this.idwordlist,
        name:this.namewordlist,
        wordlist: wordlistFormatted};
      if(this.namewordlist !== this.originalNamelist && this.namewordlist.trim() && this.wordlistInput === this.originalWordlist){
        try{
          let response = await this.fachada.editWordlist(this.http,localStorage.getItem("text-inspector-django-token"),data)
            console.log('Nombre Wordlist editada con éxito:', response);
            this.dialogRef.close(response);
            // Aquí puedes agregar lógica para cerrar el diálogo o notificar al usuario
          } catch (error){
            console.error('Error al editar el nombre Wordlist:', error);
        }
      }
      else{
        if(this.wordlistInput.trim() && this.wordlistInput !== this.originalWordlist && this.namewordlist.trim()){
          try{
          let response = await this.fachada.editWordlist(this.http,localStorage.getItem("text-inspector-django-token"),data)
            console.log('Wordlist editada con éxito:', response);
            this.dialogRef.close(response);
            // Aquí puedes agregar lógica para cerrar el diálogo o notificar al usuario
          } catch (error){
            console.error('Error al editar la Wordlist:', error);
        }
        }
      }
    }
  }
}
